export enum RelationshipType {
    SPOUSE = 'SPOUSE',
    PARTNER = 'PARTNER',
    MOTHER = 'MOTHER',
    FATHER = 'FATHER',
    BROTHER = 'BROTHER',
    SISTER = 'SISTER',
    SON = 'SON',
    DAUGHTER = 'DAUGHTER',
    BOYFRIEND = 'BOYFRIEND',
    GIRLFRIEND = 'GIRLFRIEND',
    SON_IN_LAW = 'SON_IN_LAW',
    DAUGHTER_IN_LAW = 'DAUGHTER_IN_LAW',
    MOTHER_IN_LAW = 'MOTHER_IN_LAW',
    FATHER_IN_LAW = 'FATHER_IN_LAW',
    OTHER = 'OTHER',
    DOCTOR = 'DOCTOR'
}
